export default ['$rootScope', '$q', 'httpResponseErrorService', ($rootScope, $q, httpResponseErrorService) => {
    return {
        request: config => {
            return config;
        },
        response: response => {
            return response;
        },
        responseError: (rejection) => {
            let isReject = true;

            if (rejection.status === 401) {
                $rootScope.$broadcast('http.unauthorized');
            }
            if (rejection.status === 403) {
                $rootScope.$broadcast('http.forbidden');
            }

            // status = -1 - запрос отменен по config.timeout
            if (rejection.status !== -1 && rejection.status !== 401 && rejection.status !== 403 && rejection.status !== 400 && rejection.status !== 404) {
                // allowServerErrors - флаг для идентификации запроса, для которого статус ошибка сервера является успешным
                if (rejection.allowServerErrors || rejection.config.allowServerErrors) {
                    isReject = false;
                } else if (!httpResponseErrorService.omitErrorNotification(rejection.config)) {
                    $rootScope.$broadcast('http.serverError', rejection);
                }
            }

            return isReject ? $q.reject(rejection) : $q.resolve(rejection);
        },
    };
}];
